const GetDaysBetweenDates = function (startDate, endDate) {
  var now = startDate.clone(),
    dates = [];

  while (now.isSameOrBefore(endDate)) {
    dates.push(now.format());
    now.add(1, "days");
  }
  return dates;
};

const Sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

const falsyArray = [
  false,
  0,
  "",
  null,
  undefined,
  NaN,
  "false",
  "0",
  "null",
  "undefined",
];

export { GetDaysBetweenDates, Sleep, falsyArray };
